import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPatchRequest } from '../../../api/requestUtil';
import { DraftPosition } from '../types/terrain.types';

export const fetchTopClearings = createAsyncThunk(
  'topClearings/fetch',
  async () => {
    return sendGetRequest('/api/terrain/top-clearings/');
  }
);

export const fetchMasterMap = createAsyncThunk(
  'terrain/fetchMasterMap',
  async () => {
    return sendGetRequest('/api/terrain/map/');
  }
);

export const savePositions = createAsyncThunk(
  'terrain/savePositions',
  async (positions: DraftPosition[], { getState }) => {
    // Staff only: the token identifies the admin to the backend.
    const token = (getState() as AppState).user.authToken;
    return sendPatchRequest('/api/terrain/map/positions/', { positions }, token);
  }
);
